import * as ngCore from '@angular/core'
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as markdown from '@attain-apps/fe/web/main/lib/markdown'

import * as state from '../../../../../../../../state'
import * as stores from '../../stores'
/**
 * AI Banner component for Summit Archive detail
 */
@ngCore.Component({
  imports: [ds.button.Component, markdown.Component],
  selector: 'atn-detail-ai-banner',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link DomSanitizer} */
  private readonly _sanitizer = ngCore.inject(DomSanitizer)

  /** @see {@link state.summit.archive.assistants.summarize.Feature} */
  // private readonly _summarizeAssistant = ngCore.inject(
  //   state.summit.archive.assistants.summarize.Feature,
  // )
  // /** @see {@link state.summit.archive.assistants.guide.Feature} */
  // private readonly _guideAssistant = ngCore.inject(
  //   state.summit.archive.assistants.guide.Feature,
  // )
  /** @see {@link stores.AiAssistantOrchestrator} */
  public readonly aiAssistantOrchestrator = ngCore.inject(
    stores.AiAssistantOrchestrator,
  )

  public summarizeHandler() {
    // this.aiAssistantOrchestrator.assistantSg.set(this._summarizeAssistant)
    // const assistant = this.aiAssistantOrchestrator.assistantSg()
    // if (!assistant) {
    //   return
    // }
    // assistant.actions.reset
    //   .from('Summit.Archive.Detail.Ai.Summary.Clicked')
    //   .dispatch()
    // assistant.actions.ask
    //   .from('Summit.Archive.Detail.Ai.Summary.Clicked')
    //   .dispatch({ question: '' })
  }

  public guideHandler() {
    // this.aiAssistantOrchestrator.assistantSg.set(this._guideAssistant)
    // const assistant = this.aiAssistantOrchestrator.assistantSg()
    // if (!assistant) {
    //   return
    // }
    // assistant.actions.reset
    //   .from('Summit.Archive.Detail.Ai.Guide.Clicked')
    //   .dispatch()
    // assistant.actions.ask
    //   .from('Summit.Archive.Detail.Ai.Guide.Clicked')
    //   .dispatch({ question: '' })
  }

  /**
   * Sanitizes message content to safely render HTML/markdown
   */
  public sanitizeMessageContent(content: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(content)
  }

  /**
   * Detects if content appears to be markdown (simple heuristic)
   */
  public isMarkdownContent(content: string): boolean {
    // Simple heuristics to detect markdown
    const markdownPatterns = [
      /^#{1,6}\s+/m, // Headers
      /\*\*.*\*\*/, // Bold
      /\*.*\*/, // Italic
      /```.*```/s, // Code blocks
      /`.*`/, // Inline code
      /^\* /m, // List items
      /^\d+\. /m, // Numbered lists
      /\[.*\]\(.*\)/, // Links
    ]

    return markdownPatterns.some(pattern => pattern.test(content))
  }
}
